/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object";

export default ($axios: any): any => ({
  // 알람 등록
  async store(data?: any) {
    return camelize(await $axios.post(`/alarm`, snakelize(data)));
  },

  // 알람 제거
  async delete(data?: any) {
    return camelize(await $axios.delete("/alarm", snakelize({ params: data })));
  },
});
